export default {
  INFOGRAPHIC: 'infographic',
  TABLE: 'table',
  COLLECT: 'collect',
};
